export * from './baMenu.service';



// WEBPACK FOOTER //
// ./src/app/theme/services/baMenu/index.ts